import { render, staticRenderFns } from "./DisputeResolutionTab.vue?vue&type=template&id=ddb07b3c&scoped=true&"
import script from "./DisputeResolutionTab.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb07b3c",
  null
  
)

export default component.exports